import generateRandomId from '../../../Ui/Shared/Util/generateRandomId';

import CuePosition from './Constants/CuePosition';

class Cue {
    public id: string = generateRandomId();
    public text: string = '';
    public position: CuePosition = CuePosition.DEFAULT;
}

export default Cue;